const AffiliateListTableLangKey = [
	'column_id',
	'column_name',
	'column_percent',
	'column_notes'
] as const

type IAffiliateListTableLangKey = typeof AffiliateListTableLangKey[number]

export type IAffiliateListTableLang = {
	affiliate_list_table: Record<IAffiliateListTableLangKey, string>
}

const langEntries = AffiliateListTableLangKey.map(
	(key: IAffiliateListTableLangKey) => [key, `affiliate_list_table.${key}`]
)

const langObj: Record<IAffiliateListTableLangKey, string> = Object.fromEntries(langEntries)

export const AFFILIATE_LIST_TABLE_LANG_KEY: IAffiliateListTableLang = {
	affiliate_list_table: langObj
}
